import { LabelType } from 'corgi-types';

import { dispatchTrackingEventGA4 } from 'common/tracking/dispatchTrackingEventGA4';
import { DrawerInteraction, Element } from 'common/types/tracking';

export const home24TippTrackingEvent = (eventClick: string, type: string) => {
  if (type === LabelType.Home24Selection) {
    dispatchTrackingEventGA4({
      event: eventClick,
      element: Element.Label,
      interaction: DrawerInteraction.Open,
      label_name: 'home24 tipp',
    });
  }
};
